import { useEffect, useMemo } from 'react';
import { CalendarTabs } from '../tabs';
import { useNavigate } from 'react-router-dom';
import Divider from '@/components/Divider';
import { CalendarDays } from '../calendar-days';
import { months } from '../../utils/months-list';
export const Calendar = () => {
  const navigate = useNavigate();
  const prefixUrl = '/wellbeing-awareness-days-calendar';
  const currentMonth = useMemo(() => new Date().getMonth(), []);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === prefixUrl) {
      navigate(`${prefixUrl}/${months[currentMonth].toLowerCase()}`);
    }
  }, [currentMonth, navigate]);

  return (
    <div className=" mt-sh-30 rounded-2xl border border-[#A1C4ED] p-4">
      <div className=" flex w-full flex-col justify-center">
        <CalendarTabs />
        <Divider />
        <CalendarDays />
      </div>
    </div>
  );
};
